/**
 * LA ZONA HORARIA DEL NEGOCIO, EN UN SOLO SITIO.
 *
 * El panel nació con 'America/New_York' escrito a mano en cinco archivos, porque el
 * negocio estaba en Miami. Al mudarlo a República Dominicana, todas las fechas y horas
 * que ve el equipo —las citas de la masterclass, los seguimientos, la cartera, el
 * simulador— salían una hora antes en invierno: la masterclass de las 8:00 pm se leía
 * «7:00 pm» justo en las semanas del evento del 29 de noviembre.
 *
 * Santo Domingo es UTC-4 todo el año y no tiene horario de verano. Si el negocio se
 * muda, se cambia aquí y en INSTALLATION_TIMEZONE de la API, y nada más.
 */
export const ZONA_DEL_NEGOCIO = 'America/Santo_Domingo';

/** Cómo se le nombra al equipo: «hora de Santo Domingo». */
export const LUGAR_DE_LA_HORA = 'Santo Domingo';
